import useAppStore from 'voxguru-v1/store';

const removeUserToken = () => {
  const invalidateUser = useAppStore.getState().removeUserNameAndToken;
  localStorage.removeItem('token');
  invalidateUser();
};

export default removeUserToken;
